import {combineReducers} from "redux"
import authSlice from "../_actions/auth/authReducer";
import groupService from "../_actions/group/groupReducer";
import commonService from "../_actions/commonService";
import requestsService from "../_actions/requestsService";
import hwReducer from "../_actions/student/hw/hwReducer";
import gameReduce from "../_actions/game/gameReduce";
import trainingReducer from "../_actions/training/trainingReducer";
import receiptReducer from "../_actions/receipt/receipReducer";
import notificationReducer from "../_actions/notification/notificationReducer";

export default combineReducers({
    auth: authSlice,
    common: commonService,
    hw: hwReducer,
    game: gameReduce,
    groups: groupService,
    notification: notificationReducer,
    payments: receiptReducer,
    requests: requestsService,
    training: trainingReducer,
})